import axios from 'axios';
import config from '../config';
import applyTokenRefreshInterceptor from '../utils/tokenRefreshInterceptor';
import applyAuthRetryInterceptor from '../utils/applyAuthRetryInterceptor';

const autoTraderClient = axios.create({
  baseURL: config.api.fileServiceUrl,
  timeout: 30000,
  headers: {},
});

autoTraderClient.interceptors.request.use(
  (cfg) => {
    const token = localStorage.getItem('token');
    if (token) {
      cfg.headers.Authorization = `Bearer ${token}`;
    }
    return cfg;
  },
  (error) => Promise.reject(error)
);

applyAuthRetryInterceptor(autoTraderClient);
applyTokenRefreshInterceptor(autoTraderClient);

const autoTraderService = {
  /**
   * List all available AutoTrader release zip files and their pre-signed download URLs.
   * @returns {Promise<{versions: Array<{filename, size, last_modified, download_url}>}>}
   */
  listVersions: async () => {
    const response = await autoTraderClient.get('/autotrader/versions');
    return response.data;
  },

  /**
   * Get a pre-signed download URL for a specific AutoTrader zip file.
   * @param {string} filename - e.g. 'AutoTrader-latest.zip'
   * @returns {Promise<{filename, download_url, expires_in}>}
   */
  getDownloadUrl: async (filename) => {
    const response = await autoTraderClient.get(`/autotrader/download/${encodeURIComponent(filename)}`);
    return response.data;
  },
};

export default autoTraderService;
